import React from "react";

const LINK_REGEX = /\[([^\]]+)\]\((https?:\/\/[^)]+)\)/g;

const LinkedText = ({ text }) => {
  if (!text) return null;

  const parts = [];
  let lastIndex = 0;
  let match;

  while ((match = LINK_REGEX.exec(text)) !== null) {
    if (match.index > lastIndex) {
      parts.push(text.slice(lastIndex, match.index));
    }
    const [, linkText, url] = match;
    parts.push(
      <a
        key={match.index}
        href={url}
        target="_blank"
        rel="noopener noreferrer"
        onClick={(e) => e.stopPropagation()}
      >
        {linkText}
      </a>
    );
    lastIndex = match.index + match[0].length;
  }

  if (lastIndex < text.length) {
    parts.push(text.slice(lastIndex));
  }

  return <>{parts}</>;
};

export default LinkedText;
